import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

const apiConst = {
  // 组件化活动配置
  unit_event_list: baseAPI + baseUrl + 'official/event/unit/list',
  unit_event_get_by_id: baseAPI + baseUrl + 'official/event/unit/get_by_id',
  unit_event_create: baseAPI + baseUrl + 'official/event/unit/create',
  unit_event_update: baseAPI + baseUrl + 'official/event/unit/update',
  unit_event_delete: baseAPI + baseUrl + 'official/event/unit/delete',
  unit_event_copy: baseAPI + baseUrl + 'official/event/unit/copy_to_create',
  // 榜单相关
  unit_rank_data: baseAPI + baseUrl + 'official/event/unit/rank/data',
  unit_rank_export: baseAPI + baseUrl + 'official/event/unit/rank/data/export',
  unit_rank_settlement: baseAPI + baseUrl + 'official/event/unit/rank/settlement',
  unit_rank_remove_user: baseAPI + baseUrl + 'official/event/unit/rank/remove/user',
  // 其他操作
  unit_cost_query: baseAPI + baseUrl + 'official/event/unit/cost',
  unit_award_pool_refresh: baseAPI + baseUrl + 'official/event/unit/award_pool/refresh',
  unit_task_refresh: baseAPI + baseUrl + 'official/event/unit/task/refresh',
  unit_awards_key_batch_check:
    baseAPI + baseUrl + 'official/event/unit/awards_key/batch_check',
  unit_awards_key_check_by_event:
    baseAPI + baseUrl + 'official/event/unit/awards_key/batch_check/by_event_code',
  // 活动熔断恢复
  unit_event_fuse_reset: baseAPI + baseUrl + 'official/event/unit/fuse/reset',
  // 常量接口
  constant_desc_list: '/host_admin/constant/desc/list',
}

/**
 * 获取组件化活动配置列表
 * @param {Object} params 参数 
 * @param {*} params.status 状态 0 ALL(默认) 1未开始 2进行中 3已结束
 * @param {*} params.zoneOffset 时区
 * @param {*} params.valid 是否有效 -1ALL 0无效 1有效(默认)
 * @param {*} params.page 页码 每页10条
 * @returns 
 */
export const getUnitEventListReq = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_event_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

/**
 * 根据ID获取组件化活动详情
 * @param {Number} id 活动ID
 * @returns 
 */
export const getUnitEventByIdReq = async (id) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_event_get_by_id,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      id
    }
  })
  return res
}

/**
 * 创建组件化活动
 * @param {Object} data 创建的数据
 * @returns 
 */
export const createUnitEventReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.unit_event_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: {
      ...data,
      operator: store.getters.username
    }
  })
  return res
}

/**
 * 修改组件化活动
 * @param {Object} data 修改的数据
 * @returns 
 */
export const updateUnitEventReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.unit_event_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: {
      ...data,
      operator: store.getters.username
    }
  })
  return res
}

/**
 * 删除组件化活动
 * @param {Object} info 活动信息
 * @returns 
 */
export const deleteUnitEventReq = async (info) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_event_delete,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      id: info.id,
      eventCode: info.eventCode
    }
  })
  return res
}

/**
 * 复制组件化活动配置
 * @param {String} eventCode 活动码
 * @returns 
 */
export const copyUnitEventReq = async (eventCode) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_event_copy,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      eventCode
    }
  })
  return res
}

/**
 * 查询活动成本
 * @param {String} eventCode 活动码
 * @returns 
 */
export const getUnitEventCostReq = async (eventCode) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_cost_query,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      eventCode
    }
  })
  return res
}

/**
 * 批量检查礼包key是否有效
 * @param {Array<string>} awardsKeys 礼包key列表
 * @returns
 */
export const batchCheckUnitAwardsKeyReq = async (awardsKeys = []) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.unit_awards_key_batch_check,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: awardsKeys,
  })
  return res
}

/**
 * 根据活动code检查组件中使用的礼包key是否有效
 * @param {String|Number} eventCode 活动码
 * @returns
 */
export const checkUnitAwardsKeyByEventCodeReq = async (eventCode) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_awards_key_check_by_event,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      eventCode,
    },
  })
  return res
}

/**
 * 查询榜单组件数据
 * @param {Object} params 参数
 * @param {String} params.eventCode 活动码
 * @param {Number} params.unitId 组件id
 * @param {Number} params.top 显示top数量 默认10最大100
 * @returns 
 */
export const getUnitRankDataReq = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_rank_data,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

/**
 * 导出榜单数据
 * @param {Object} params 参数
 * @param {String} params.eventCode 活动码
 * @param {Number} params.unitId 组件id
 * @param {Number} params.top 显示top数量 默认10最大100
 * @returns 
 */
export const exportUnitRankDataReq = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_rank_export,
    withCredentials: true,
    responseType: 'blob',
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

/**
 * 榜单结算
 * @param {Object} params 参数
 * @param {String} params.eventCode 活动码
 * @param {Number} params.unitId 组件id
 * @param {String} params.settlementKey 执行密钥
 * @returns 
 */
export const unitRankSettlementReq = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_rank_settlement,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

/**
 * 移除榜单用户数据
 * @param {Object} params 参数
 * @param {String} params.eventCode 活动码
 * @param {Number} params.unitId 组件id
 * @param {String} params.uid 被移除的用户id
 * @returns 
 */
export const removeUnitRankUserReq = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_rank_remove_user,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

/**
 * 刷新奖池
 * @param {Object} params 参数
 * @param {String} params.eventCode 活动码
 * @param {Number} params.unitId 组件id
 * @returns 
 */
export const refreshUnitAwardPoolReq = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_award_pool_refresh,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

/**
 * 刷新任务组件
 * @param {Object} params 参数
 * @param {String} params.eventCode 活动码
 * @param {Number} params.unitId 组件id
 * @param {Number} params.rid 用户id
 * @returns 
 */
export const refreshUnitTaskReq = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_task_refresh,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

/**
 * 活动熔断恢复
 * @param {Object} params 参数
 * @param {Number} params.eventCode 活动码
 * @param {String} params.username 操作人
 * @param {String} params.resetFuseKey 重置密钥
 * @returns 
 */
export const resetUnitEventFuseReq = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.unit_event_fuse_reset,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
} 

/**
 * 获取常量列表
 * @param {String} constantKey 常量key，如：com.quhong.constant.activity.model.event.mode.ZoneOffsetConstant
 * @returns 
 */
export const getConstantListReq = async (className) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.constant_desc_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      className
    }
  })
  return res
}
